import React, { Component } from 'react';
import { Box, Button, Stack } from '@mui/material';

class ItemButtons extends Component {
  render() {
    const itemTitle = this.props.item.title;
    const informationButton = {
      title:
        this.props.item.informationTitle?.toLowerCase() === 'info'
          ? 'Get More Info'
          : this.props.item.informationTitle,
      url: this.props.item.informationUrl,
    };
    const statusButton = {
      title: this.props.item.statusTitle,
      url: this.props.item.statusUrl,
    };
    const actionButton = {
      title: this.props.item.actionLinkTitle,
      url: this.props.item.actionLinkUrl,
    };
    return (
      <Stack
        sx={{ width: '100%', mt: 2 }}
        direction={{ xs: 'col', sm: 'row' }}
        spacing={1}
        alignItems={'center'}
        justifyContent="flex-end"
        role="group"
        aria-label={`Actions for ${itemTitle}`}
      >
        {informationButton.title && informationButton.url && (
          <Button
            id={'checklist__button_item_' + itemTitle.replace(/\s/g, '') + '_firstButton'}
            onClick={() => window.open(informationButton.url, '_blank', 'noopener,noreferrer')}
            className="myOdu__button secondary checklistButton"
            variant="outlined"
            size="small"
            aria-label={`${itemTitle} - Get more info (opens in new window)`}
          >
            {informationButton.title}
          </Button>
        )}
        {statusButton.title && statusButton.url && (
          <Button
            id={'checklist__button_item_' + itemTitle.replace(/\s/g, '') + '_secondButton'}
            onClick={() => window.open(statusButton.url, '_blank', 'noopener,noreferrer')}
            className="myOdu__button primary checklistButton"
            variant="outlined"
            size="small"
            aria-label={`${itemTitle} - ${statusButton.title} (opens in new window)`}
          >
            {statusButton.title}
          </Button>
        )}
        {actionButton.title && actionButton.url && (
          <Button
            id={'checklist__button_item_' + itemTitle.replace(/\s/g, '') + '_thirdButton'}
            onClick={() => window.open(actionButton.url, '_blank', 'noopener,noreferrer')}
            className="myOdu__button primary checklistButton"
            variant="outlined"
            size="small"
            aria-label={`${itemTitle} - ${actionButton.title} (opens in new window)`}
          >
            {actionButton.title}
          </Button>
        )}
      </Stack>
    );
  }
}

export default ItemButtons;
